import script from "./WaveDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./WaveDivider.vue?vue&type=script&setup=true&lang=js"

import "./WaveDivider.vue?vue&type=style&index=0&id=192b8d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192b8d28"]])

export default __exports__